<template>
  <div class="resignation">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Retirement</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Retirement</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a @click="openDialog" class="btn add-btn"
                  ><i class="fa fa-plus"></i> Add Retirement</a
                >
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <v-data-table
                  :headers="headers"
                  :items="resignations"
                  sort-by="firstName"
                  class="elevation-1"
                >
                  <template v-slot:[`item.retirementDate`]="{ item }">
                    {{
                      item.retirementDate
                        ? new Date(item.retirementDate).toLocaleDateString()
                        : ""
                    }}
                  </template>
                  <template v-slot:[`item.noticeDate`]="{ item }">
                    {{
                      item.noticeDate
                        ? new Date(item.noticeDate).toLocaleDateString()
                        : ""
                    }}
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right" v-if="item.exitInterview.document">
                        <a
                          class="dropdown-item"
                          v-if="item.status == 0"
                          @click="setWithdrawRetirement(item)"
                          ><i class="fa fa-pencil m-r-5"></i> Withdraw</a
                        >
                        <a
                          class="dropdown-item"
                          v-if="item.status == 0"
                          @click="setEditResignation(item)"
                          ><i class="fa fa-pencil m-r-5"></i> Edit</a
                        >
                        <a
                          class="dropdown-item"
                          v-if="!item.exitInterview.document"
                          @click="setDeleteResignation(item)"
                          ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                        >
                      </div>
                      <div class="dropdown-menu dropdown-menu-right" v-else>
                                                <a
                          class="dropdown-item"
                          v-if="item.status == 0"
                          @click="
                            getPolicyDocument()
                          "
                          ><i class="fa fa-download m-r-5"></i> Download Exit
                          Interview Form</a
                        >
                        <a
                          class="dropdown-item"
                          v-if="item.status == 0"
                          @click="openDialogUplaod(item)
                          "
                          ><i class="fa fa-download m-r-5"></i> Upload Document</a
                        >
                        <a
                          class="dropdown-item"
                          v-if="item.status == 0"
                          @click="setWithdrawRetirement(item)"
                          ><i class="fa fa-pencil m-r-5"></i> Withdraw</a
                        >
                        <a
                          class="dropdown-item"
                          v-if="item.status == 0"
                          @click="setEditResignation(item)"
                          ><i class="fa fa-pencil m-r-5"></i> Edit</a
                        >
                        <a
                          class="dropdown-item"
                          v-if="!item.exitInterview.document"
                          @click="setDeleteResignation(item)"
                          ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                        >
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.stat`]="{ item }">
                    <div v-if="item.exitInterview.document">
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 0 && item.exitInterview.document"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> Document Uploaded
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.exitInterview.interviewDate !== '0001-01-01T00:00:00' && item.status == 0"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-info"></i> Pending
                      Interview
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 1"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Approved
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 2"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-danger"></i> Declined
                    </a>

                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 3"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-secondary"></i>
                      Withdrawn
                    </a>
                    </div>
                    <div v-else>
                     <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 0"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> New
                    </a>
                    </div>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->
         <!-- Send Interview Invitation Modal -->
        <v-dialog v-model="dialogUpload" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Upload Your Answers On The Document</h5>
              <button type="button" class="close" @click="closeUpload">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="onSubmit">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Upload Form</label>
                    <div class="custom-file" v-if="!file">
                      <input type="file" class="custom-file-input" id="cv_upload" @change="onFilePicked" />
                      <label class="custom-file-label" for="cv_upload">Choose file</label>
                    </div>
                    <div class="row" v-if="file">
                      <div class="col-md-6">
                        <span>{{ fileName }}</span>
                      </div>
                      <div class="col-md-6">
                        <a class="btn btn-primary" @click="changeFile">Change File</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="submit-section">
                  <button @click.prevent="onUpload" data-dismiss="modal" class="btn btn-primary submit-btn"
                    :disabled="submitted">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Send Interview Invitation Modal -->
        <!-- Add Resignation Modal -->
        <v-dialog v-model="dialog" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add Retirement</h5>
              <button type="button" class="close" @click="close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="onSubmit">
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-if="error"
                    >
                      <strong>Error!</strong> {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div
                      class="alert alert-success alert-dismissible fade show"
                      role="alert"
                      v-if="message"
                    >
                      <strong>Success!</strong> {{ message }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label
                    >Retirement Date <span class="text-danger">*</span></label
                  >
                  <div class="cal-icon">
                    <datepicker
                      v-model="retirementDate"
                      calendar-class
                      input-class
                      bootstrap-styling
                      class="form-control datetimepicker"
                      type="text"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label>Reason <span class="text-danger">*</span></label>
                  <textarea
                    class="form-control"
                    v-model="reason"
                    rows="4"
                  ></textarea>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>Upload Retiement Letter</label>
                      <div class="custom-file">
                        <input
                          type="file"
                          name="file"
                          class="form-control"
                          id="cv_upload"
                          @change="onFilePicked"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <a
                      @click="importEmployeeRetirmentLetter"
                      v-if="file"
                      class="btn btn-primary continue-btn"
                      data-dismiss="modal"
                    >
                      Upload</a
                    >
                  </div>
                </div>
                <div class="submit-section">
                  <button
                    @click.prevent="onSubmit"
                    data-dismiss="modal"
                    class="btn btn-primary submit-btn"
                    :disabled="submitted"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Add Resignation Modal -->

        <!-- Edit Resignation Modal -->
        <v-dialog v-model="dialogEdit" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edit Retirement</h5>
              <button type="button" class="close" @click="closeEdit">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="updateEmployeeResignation">
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-if="error"
                    >
                      <strong>Error!</strong> {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div
                      class="alert alert-success alert-dismissible fade show"
                      role="alert"
                      v-if="message"
                    >
                      <strong>Success!</strong> {{ message }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label>Notice Date <span class="text-danger">*</span></label>
                  <div class="cal-icon">
                    <datepicker
                      v-model="resignation.noticeDate"
                      calendar-class
                      input-class
                      bootstrap-styling
                      class="form-control datetimepicker"
                      type="text"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label
                    >Retirement Date <span class="text-danger">*</span></label
                  >
                  <div class="cal-icon">
                    <datepicker
                      v-model="resignation.retirementDate"
                      calendar-class
                      input-class
                      bootstrap-styling
                      class="form-control datetimepicker"
                      type="text"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label>Reason <span class="text-danger">*</span></label>
                  <textarea
                    class="form-control"
                    v-model="resignation.reason"
                    rows="4"
                  ></textarea>
                </div>

                <div class="submit-section">
                  <button class="btn btn-primary submit-btn">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Edit Resignation Modal -->

        <!-- Delete Resignation Modal -->
        <v-dialog v-model="dialogDelete" max-width="725px">
          <div class="row">
            <div class="col-md-12">
              <div
                class="alert alert-danger alert-dismissible fade show"
                role="alert"
                v-if="error"
              >
                <strong>Error!</strong> {{ error }}
                <button
                  type="button"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div class="col-md-12">
              <div
                class="alert alert-success alert-dismissible fade show"
                role="alert"
                v-if="message"
              >
                <strong>Success!</strong> {{ message }}
                <button
                  type="button"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <button type="button" class="close" @click="closeDelete">
                  <span aria-hidden="true">&times;</span>
                </button>
                <h3>Delete Retirement</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click.prevent="deleteEmployeeResignation"
                      class="btn btn-primary continue-btn"
                      data-dismiss="modal"
                      >Delete</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      data-dismiss="modal"
                      @click="closeDelete"
                      class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete Resignation Modal -->

        <!--  -->

        <v-dialog v-model="dialogWithdraw" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <button type="button" class="close" @click="closeWithdraw">
                  <span aria-hidden="true">&times;</span>
                </button>
                <h3>Withdraw Retirement</h3>
                <p>Are you sure want to withdraw?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click.prevent="withdrawEmployeeRetirement"
                      class="btn btn-primary continue-btn"
                      data-dismiss="modal"
                      >Yes</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      data-dismiss="modal"
                      @click="closeWithdraw"
                      class="btn btn-primary cancel-btn"
                      >No</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/employeeSidebar.vue";
import { required, sameAs } from "vuelidate/lib/validators";
import { employeeService } from "@/services/employeeService.js";
import Datepicker from "vuejs-datepicker";
import { organizationService } from "@/services/organizationService";
import { authenticationService } from "@/services/authenticationService";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker
  },

  data() {
    return {
      dialog: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogWithdraw: false,
      dialogUpload: false,
      headers: [
        { text: "Retirement Date", value: "retirementDate" },
        { text: "Reason", value: "reason" },
        { text: "Interview Date", value: "exitInterview.interviewDate" },
        { text: "Status", value: "stat" },
        { text: "", value: "actions", sortable: false }
      ],
      name: "",
      employeeId: "",
      reason: "",
      noticeDate: "",
      retirementDate: "",
      resignation: {},
      resignations: [],
      employee: [],
      loading: false,
      error: "",
      message: "",
      employees: [],
      submitted: false,
      user: authenticationService.currentUserValue,
      company: authenticationService.currentOfficeValue,
      file: null,
      fileName: ""
    };
  },

  validations: {
    name: { required },
    reason: { required },
    noticeDate: { required },
    retirementDate: { required }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogEdit(val) {
      val || this.closeEdit();
    },
    dialogUpload(val) {
      val || this.closeUpload();
    }
  },
  methods: {
    // getEmployees(id) {
    //   employeeService.getEmployees(id).then(
    //     (model) => {
    //       console.log(model);
    //       this.employees = model;
    //     },
    //     (error) => {
    //       error = error;
    //     }
    //   );
    // },
    onFilePicked(event) {
      const files = event.target.files
      this.fileName = files[0].name
      this.file = files[0];
    },

    changeFile(){
      this.file = null
      this.fileName = ''
    },
    onUpload() {
      this.submitted = true;


      this.loading = true;
      employeeService
        .addRetireExitDocument(
          this.company.id,
          this.resignation.id,
          this.file
        )
        .then(
          (id) => {
            employeeService.getEmployeeRetirementsByEmployee(this.user.employee.id).then((w) => {
              this.resignations = w;
              this.closeUpload();
              this.loading = false;
              this.submitted = false;
            });
          },
          (error) => {
            this.error = error;
            this.loading = false;
            this.submitted = false;
          }
        );
    },

    importEmployeeRetirmentLetter() {
      employeeService.importEmployee(this.company.id, this.file).then(
        response => {
          var unit = JSON.parse(localStorage.getItem("companyUnit"));
          employeeService.getEmployees(unit.id).then(model => {
            (this.employees = model), (this.filterEmployees = model);
            //this.message = '';
            this.dialogImport = false;
          });
        },
        error => {
          this.error = error;
        }
      );
    },
    getPolicyDocument() {
      organizationService.getPolicyDocument("C:\\inetpub\\wwwroot\\SapphireAPI\\Document\\redstar\\1\\ExitForm\\EXIT INTERVIEW FORM.doc").then(
        model => {
          let blob = new Blob([model.data], { type: model.data.type });
          // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, model.fileName);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // Create a download link
            downloadElement.href = href;
            downloadElement.download = model.fileName; // Download the file name
            document.body.appendChild(downloadElement);
            downloadElement.click(); // click to download
            document.body.removeChild(downloadElement); // Download complete removal element
            window.URL.revokeObjectURL(href); // Release Blob object
          }
        },
        error => {
          error = error;
        }
      );
    },
    getEmployeeResignations() {
      employeeService
        .getEmployeeRetirementsByEmployee(this.user.employee.id)
        .then(
          model => {
            // console.log(model)
            model.forEach(a => {
              if (!a.exitInterview) {
                a.exitInterview = {};
              }
            });
            this.resignations = model;
          },
          error => {
            error = error;
          }
        );
    },

    clearModel() {
      this.employeeId = "";
      this.reason = "";
      this.noticeDate = "";
      this.retirementDate = "";
      this.submitted = false
    },

    openDialog() {
      this.dialog = true;
    },
    openDialogUplaod(item) {
      this.dialogUpload = true;
      this.resignation = item;
    },
    closeUpload() {
      this.dialogUpload = false;
    },

    setWithdrawRetirement(model) {
      this.resignation = model;
      this.dialogWithdraw = true;
    },
    closeWithdraw() {
      this.dialogWithdraw = false;
    },

    close() {
      this.dialog = false;
      this.clearModel();
    },
    closeEdit() {
      this.dialogEdit = false;
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    setEditResignation(model) {
      this.resignation = model;
      this.dialogEdit = true;
    },
    setDeleteResignation(model) {
      this.resignation = model;
      this.dialogDelete = true;
    },

    onSubmit() {
      this.submitted = true;

      if (this.reason == "") {
        return (this.error = "Enter retirement reasons");
      }

      this.loading = true;
      employeeService
        .addEmployeeRetirement(
          this.retirementDate,
          this.reason,
          new Date(),
          this.user.employee.id
        )
        .then(
          id => {
            employeeService
              .getEmployeeRetirementsByEmployee(this.user.employee.id)
              .then(w => {
                w.forEach(a => {
                  if (!a.exitInterview) {
                    a.exitInterview = {};
                  }
                });
                this.resignations = w;
                this.close();
              });
          },
          error => {
            this.error = error;
            this.loading = false;
          }
        );
    },
    updateEmployeeResignation() {
      this.submitted = true;

      this.loading = true;
      // console.log(this.resignation)
      employeeService
        .updateEmployeeRetirement(this.resignation.id, this.resignation)
        .then(
          id => {
            employeeService
              .getEmployeeRetirementsByEmployee(this.user.employee.id)
              .then(o => {
                o.forEach(a => {
                  if (!a.exitInterview) {
                    a.exitInterview = {};
                  }
                });
                (this.resignations = o),
                  //console.log(o),
                  this.closeEdit();
              });
          },
          error => {
            this.error = error;
            this.loading = false;
          }
        );
    },

    withdrawEmployeeRetirement() {
      this.submitted = true;

      this.loading = true;
      this.resignation.status = 3;
      // console.log(this.resignation)
      employeeService
        .updateEmployeeRetirement(this.resignation.id, this.resignation)
        .then(
          id => {
            employeeService
              .getEmployeeRetirementsByEmployee(this.user.employee.id)
              .then(o => {
                o.forEach(a => {
                  if (!a.exitInterview) {
                    a.exitInterview = {};
                  }
                });
                (this.resignations = o),
                  //console.log(o),
                  (this.dialogWithdraw = false);
              });
          },
          error => {
            this.error = error;
            this.loading = false;
          }
        );
    },
    deleteEmployeeResignation() {
      const id = this.resignation.id;
      // console.log(this.resignation)
      employeeService.removeEmployeeRetirement(id).then(id => {
        employeeService
          .getEmployeeRetirementsByEmployee(this.user.employee.id)
          .then(
            model => {
              model.forEach(a => {
                if (!a.exitInterview) {
                  a.exitInterview = {};
                }
              });
              this.resignations = model;
              // console.log(model)
              this.closeDelete();
            },
            error => {
              error = error;
            }
          );
      });
    }
  },

  mounted() {
    this.getEmployeeResignations();
    // Datatable
    //this.getEmployees(this.employee.id);
    //this.getEmployeeResignations(this.company.id);

    if ($(".datatable").length > 0) {
      $(".datatable").DataTable({
        bFilter: false
      });
    }
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "resignation"
};
</script>



// WEBPACK FOOTER //
// src/components/retirement/retirementEmployee.vue